import React from "react";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import { getOtherStoreDefinition } from "../stores";

function RedeemCodesLink({ storeId, count = 1 }) {
  const redeem = getOtherStoreDefinition(storeId)?.redeem;
  if (!redeem) {
    return null;
  }

  return (
    <div className="other-store-redeem">
      <div className="other-store-redeem-actions">
        <a
          href={redeem.url}
          target="_blank"
          rel="noopener noreferrer"
          className={`other-store-redeem-btn${redeem.tone ? ` other-store-redeem-btn--${redeem.tone}` : ""}`}
        >
          {count > 1 ? "Активировать коды" : "Активировать код"} на сайте {redeem.site}
          <ArrowTopRightOnSquareIcon className="h-4 w-4" aria-hidden="true" />
        </a>
        {redeem.appUrl ? (
          <a href={redeem.appUrl} className="other-store-redeem-app">
            {redeem.appLabel}
          </a>
        ) : null}
      </div>
      {redeem.hint ? <p className="other-store-redeem-hint">{redeem.hint}</p> : null}
    </div>
  );
}

export default RedeemCodesLink;
